import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  getUserRole,
  getUserDetails,
} from "../../../backend/auth";
import {
  DEFAULT_OPTIONS_PAYLOAD,
} from "../../common/Table";
import {
  useGetVendorHeirarchyRecords,
} from "../../../backend/masters";
import downloadButton from "./../../../assets/img/icon/downloadButton.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useExportSummaryAuditReport } from "../../../backend/exports";
import { toast } from "react-toastify";

const monthOptions = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' },
  ];

function VendorAuditDashboardFilter({ onChange }: any) {
  const _role = getUserRole();
  const user = getUserDetails();
  const [t] = useState(new Date().getTime());
  const [company, setCompany] = useState<any>(null);
  const [associate_company, setAssociateCompany] = useState<any>(null);
  const [location, setLocation] = useState<any>(null);
  const [vendorCategoriesId, setVendorCategoriesId] = useState<any>(null);
  const [vendorRegistrationId, setVendorRegistrationId] = useState<any>(null);
  const [month, setMonth] = useState<any>(null);
  const [year, setYear] = useState<any>(null);

  // State for hierarchical data
  const [associateCompanies, setAssociateCompanies] = useState<any>(null);
  const [locations, setLocations] = useState<any>(null);
  const [categories, setCategories] = useState<any>(null);
  const [vendors, setVendors] = useState<any>(null);

  // Year options - Current year and past 5 years
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 10 }, (_, i) => ({
    value: currentYear - i,
    label: (currentYear - i).toString(),
  }));

  // User-specific API call - gets hierarchical data
  const { companies: parentCompanies, isFetching: fetchingCompanies } =
    useGetVendorHeirarchyRecords({
      filters: {
        user_id_eq: user.user_id
      }
    });

  const { exportSummaryAuditReport, exporting } = useExportSummaryAuditReport(
    (response: any) => {
      toast.success(response.message);
    },
    (error: any) => {
      const errorMessage = (error && error.response && error.response.data && error.response.data.message);
      toast.error(errorMessage);
    }
  );

  // Navigate hierarchical data when company changes
  useEffect(() => {
    if (company && parentCompanies) {
      const _company = parentCompanies.find((c: any) => c.id == company.value);
      setAssociateCompanies(_company && _company.associate_companies ? _company.associate_companies : []);
      setAssociateCompany(null);
      setLocation(null);
      setVendorCategoriesId(null);
      setVendorRegistrationId(null);
    }
  }, [company]);

  // Navigate to locations when associate company changes
  useEffect(() => {
    if (associate_company && parentCompanies && company) {
      const _company = parentCompanies.find((c: any) => c.id == company.value);
      const _associateCompany = _company && _company.associate_companies
        ? _company.associate_companies.find((c: any) => c.id == associate_company.value)
        : null;
      setLocations(_associateCompany && _associateCompany.locations ? _associateCompany.locations : []);
      setLocation(null);
      setVendorCategoriesId(null);
      setVendorRegistrationId(null);
    }
  }, [associate_company]);

  // Navigate to categories when location changes
  useEffect(() => {
    if (location && parentCompanies && company && associate_company) {
      const _company = parentCompanies.find((c: any) => c.id == company.value);
      const _associateCompany = _company && _company.associate_companies
        ? _company.associate_companies.find((c: any) => c.id == associate_company.value)
        : null;
      const _location = _associateCompany && _associateCompany.locations
        ? _associateCompany.locations.find((c: any) => c.id == location.value)
        : null;
      setCategories(_location && _location.categories ? _location.categories : []);
      setVendorCategoriesId(null);
      setVendorRegistrationId(null);
    }
  }, [location]);

  // Navigate to vendors when category changes
  useEffect(() => {
    if (vendorCategoriesId && parentCompanies && company && associate_company && location) {
      const _company = parentCompanies.find((c: any) => c.id == company.value);
      const _associateCompany = _company && _company.associate_companies
        ? _company.associate_companies.find((c: any) => c.id == associate_company.value)
        : null;
      const _location = _associateCompany && _associateCompany.locations
        ? _associateCompany.locations.find((c: any) => c.id == location.value)
        : null;
      const _category = _location && _location.categories
        ? _location.categories.find((c: any) => c.id == vendorCategoriesId.value)
        : null;
      setVendors(_category && _category.vendors ? _category.vendors : []);
      setVendorRegistrationId(null);
    }
  }, [vendorCategoriesId]);


  const handleChangeCompany = (selectedCompany: any) => {
    setCompany(selectedCompany);
    setAssociateCompany(null);
    setLocation(null);
    setVendorCategoriesId(null);
    setVendorRegistrationId(null);
    // Clear dependent dropdown options when company is cleared
    if (!selectedCompany) {
      setAssociateCompanies([]);
      setLocations([]);
      setCategories([]);
      setVendors([]);
    }
  };
  const handleChangeAssocaiteCompany = (selectedCompany: any) => {
    setAssociateCompany(selectedCompany);
    setLocation(null);
    setVendorCategoriesId(null);
    setVendorRegistrationId(null);
    if (!selectedCompany) {
      setLocations([]);
      setCategories([]);
      setVendors([]);
    }

  };
  const handleChangeLocation = (selectedCompany: any) => {
    setLocation(selectedCompany);
    setVendorCategoriesId(null);
    setVendorRegistrationId(null);
    setCategories([]);
    setVendors([]);
  };
  const handleChangeVendorCategories = (selectedCategory: any) => {
    setVendorCategoriesId(selectedCategory);
    setVendorRegistrationId(null);
    if (!selectedCategory) {
      setVendors([]);
    }
  };

  const handleChangeMonth = (selectedMonth: any) => {
    setMonth(selectedMonth);
  };

  const handleChangeYear = (selectedYear: any) => {
    setYear(selectedYear);
  };


  useEffect(() => {
    if (associate_company) {
      setLocation(null);
      setVendorCategoriesId(null);
      setVendorRegistrationId(null);
      // setMonth(undefined);  
      // setYear(undefined);   
      // vendorMappingRefetch();
    }
  }, [associate_company]);


  // Auto-select current year on load (company should remain null for "All")
  useEffect(() => {
    if (!year) {
      const currentYear = new Date().getFullYear();
      const yearOption = yearOptions.find(opt => opt.value === currentYear);
      if (yearOption) {
        setYear(yearOption);
      }
    }
  }, []);

  // Trigger onChange when companies are loaded or year changes
  useEffect(() => {
    if (!fetchingCompanies && parentCompanies) {
      // If no company selected, send all company IDs
      const companyIds = company
        ? [company.value]
        : parentCompanies.map((c: any) => c.id);

      onChange({
        company: company ? company.value : null,
        associate_company: associate_company ? associate_company.value : null,
        location_id: location ? location.value : null,
        vendor_category_id: vendorCategoriesId ? vendorCategoriesId.value : null,
        vendor_registration_id: vendorRegistrationId ? vendorRegistrationId.value : null,
        month: month ? month.value : null,
        year: year ? year.value : null,
        all_company_ids: companyIds,
      });
    }
  }, [fetchingCompanies, parentCompanies, company, associate_company, location, vendorCategoriesId, vendorRegistrationId, month, year]);
  
  const isDownloadEnabled = () => {
      return !!(company && associate_company && month && year);
    };

    // Get missing required fields for tooltip
    const getMissingFields = () => {
      const missing: string[] = [];
      if (!company) missing.push('Company');
      if (!associate_company) missing.push('Associate Company');
      if (!month) missing.push('Month');
      if (!year) missing.push('Year');
      return missing;
    };

    // Format month_year as "MonthName Year"
    const formatMonthYear = () => {
      if (!month || !year) return '';
      const monthOption = monthOptions.find(m => m.value === month.value);
      const monthName = monthOption ? monthOption.label : '';
      return `${monthName} ${year.value}`;
    };

    // Handle download button click
    const handleDownloadClick = () => {
      if (!isDownloadEnabled()) {
        return; // Button is disabled, do nothing
      }

      // Build payload
      const payload: any = {
        company_id: company.value,
        associate_company_id: associate_company.value,
        month_year: formatMonthYear()
      };

      // Add optional filters if selected
      if (location) {
        payload.location_ids = [location.value];
      }
      if (vendorCategoriesId) {
        payload.vendor_category_ids = [vendorCategoriesId.value];
      }
      if (vendorRegistrationId) {
        payload.vendor_registration_ids = [vendorRegistrationId.value];
      }

      // Call export API
      exportSummaryAuditReport(payload);
    };

    // Get tooltip message
    const getTooltipMessage = () => {
      const missing = getMissingFields();
      if (missing.length === 0) return 'Download Report';
      return `Select ${missing.join(', ')} first`;
    };

  return (
    <>
      <div className="flex-grow-1">
        <label className="filter-label">
          Company
        </label>
        <Select
          placeholder="All"
          options={(parentCompanies || []).map((x: any) => ({
             value: x.id, label: x.name
          }))}
          onChange={handleChangeCompany}
          value={company}
          isClearable
          className="select-control"
        />
      </div>
      <div className="flex-grow-1">
        <label className="filter-label">
          Associate Company
        </label>
        <Select
          placeholder="All"
          options={(associateCompanies || []).map((x: any) => ({
            value: x.id,
            label: x.name,
          }))}
          onChange={handleChangeAssocaiteCompany}
          value={associate_company}
          isClearable
          isDisabled={!company}
          className="select-control"
        />
      </div>
      <div className="flex-grow-1">
        <label className="filter-label">
          Location
        </label>
        <Select
          placeholder="All"
          options={(locations || []).map((loc: any) => ({
            value: loc.id,
            label: loc.name,
          }))}
          onChange={handleChangeLocation}
          value={location || null}
          isClearable
          isDisabled={!company || !associate_company}
          className="select-control"
        />
      </div>
      <div className="flex-grow-1">
        <label className="filter-label">
          Vendor Category
        </label>
        <Select
          placeholder="All"
          options={(categories || []).map((x: any) => ({
            value: x.id,
            label: x.name
          }))}
          onChange={(e) => {
            handleChangeVendorCategories(e);
          }}
          value={vendorCategoriesId || null}
          isClearable
          isDisabled={!company || !associate_company || !location}
          className="select-control"
        />
      </div>
      <div className="flex-grow-1">
        <label className="filter-label">
          Vendor
        </label>
        <Select
          placeholder="All"
          options={(vendors || []).map((x: any) => ({
            value: x.id,
            label: x.name,
          }))}
          onChange={setVendorRegistrationId}
          value={vendorRegistrationId || null}
          isClearable
          isDisabled={!company || !associate_company || !location || !vendorCategoriesId}
          className="select-control"
        />
      </div>
      <div className="flex-grow-1">
        <label className="filter-label">
          Month
        </label>
        <Select
          placeholder="All"
          options={monthOptions}
          onChange={handleChangeMonth}
          value={month}
          isClearable
          className="select-control"
        />
      </div>
      <div className="flex-grow-1">
        <label className="filter-label">
          Year
        </label>
        <Select
          placeholder="Select Year"
          options={yearOptions}
          onChange={handleChangeYear}
          value={year}
          // isClearable
          className="select-control"
        />
      </div>
      <div>
          <label className="filter-label"></label>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="download-tooltip">
                {getTooltipMessage()}
              </Tooltip>
            }
          >
            <div
              className={`border p-1 ${isDownloadEnabled() ? 'cursor-pointer' : 'cursor-not-allowed'}`}
              style={{
                borderRadius: "8px",
                opacity: isDownloadEnabled() ? 1 : 0.4,
                transition: "opacity 0.2s"
              }}
              onClick={handleDownloadClick}
            >
              <img
                className="d-block"
                src={downloadButton}
                alt="downloadButton"
                style={{ pointerEvents: 'none' }}
              />
            </div>
          </OverlayTrigger>
        </div>
    </>
  );
}

export default VendorAuditDashboardFilter;
